<template>
  <div style="position: relative; height: 350px;">
    <canvas ref="canvasRef" style="width: 100%; height: 100%;"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { nextTick, toRaw } from 'vue'; // Keep toRaw
Chart.register(...registerables);

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  // We no longer need 'chart' in data() because we'll store it differently
  // data() {
  //   return {
  //     chart: null,
  //   };
  // },
  created() {
    // Initialize a non-reactive property to hold the chart instance.
    // Properties prefixed with _ are often used to denote internal, non-reactive state.
    this._chartInstance = null;
  },
  mounted() {
    // Ensure the DOM is updated before trying to create the chart
    nextTick(() => this.createChart());
  },
  watch: {
    data: {
      // When the 'data' prop changes, update the chart
      handler() {
        nextTick(() => this.updateChart());
      },
      deep: true // Watch for changes within the data array itself
    }
  },
  beforeUnmount() {
    // Clean up the chart instance before the component is unmounted
    this.destroyChart();
  },
  methods: {
    // Utility: sanitize raw data to avoid Vue proxies
    sanitizeData(rawData) {
      // Use toRaw to get the raw JavaScript object from a Vue reactive proxy
      const unwrappedData = toRaw(rawData);
      // Map to new plain objects to further ensure no reactivity issues
      return unwrappedData.map(item => ({
        label: item.label,
        value: item.value,
      }));
    },
    createChart() {
      const canvas = this.$refs.canvasRef;
      if (!canvas) {
        console.warn('Canvas element not found for chart creation.');
        return;
      }
      const ctx = canvas.getContext('2d');
      // Destroy any existing chart instance before creating a new one
      this.destroyChart();

      // Get plain, non-reactive data for Chart.js
      const plainData = this.sanitizeData(this.data);

      // Assign the new Chart instance to the non-reactive property
      this._chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: plainData.map(i => i.label),
          datasets: [{
            label: 'عدد الردود', // Label for the dataset
            data: plainData.map(i => i.value),
            backgroundColor: ['#4caf50', '#ff9800', '#f44336', '#9e9e9e'], // Custom colors
          }]
        },
        options: {
          responsive: true, // Make the chart responsive to container size changes
          maintainAspectRatio: false, // Allow the chart to fill the given height
          plugins: {
            legend: { display: false }, // Hide the legend
            tooltip: {} // Enable tooltips on hover
          },
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    },
    updateChart() {
      // Use the non-reactive chart instance
      if (!this._chartInstance) {
        this.createChart();
        return;
      }

      // Get plain, non-reactive updated data
      const plainData = this.sanitizeData(this.data);

      // Update chart data on the non-reactive instance
      this._chartInstance.data.labels = plainData.map(i => i.label);
      this._chartInstance.data.datasets[0].data = plainData.map(i => i.value);

      // Trigger chart update to re-render with new data
      this._chartInstance.update();
    },
    destroyChart() {
      // Destroy the chart instance if it exists to prevent memory leaks
      if (this._chartInstance) {
        this._chartInstance.destroy();
        this._chartInstance = null; // Clear the chart reference
      }
    }
  }
};
</script>

<style scoped>
/* Your styles here if any */
</style>